// This provides a common reference point to globals.js and other environment variables
// for React context, plain JS, and anything else that might need to use
// environment-specific globals. It also allows simple mocking of globals during unit testing,
// although the module itself isn't really testable.
const globals = {
  ...(window.MD || {}),
  CSS_PREFIX: process.env.CSS_PREFIX,
  F2_APP_ID_PREFIX: process.env.F2_APP_ID_PREFIX,
  MD_ROOT_CLASS: process.env.MD_ROOT_CLASS,
  PUBLIC_ASSET_URL_BASE: process.env.PUBLIC_ASSET_URL_BASE,
  ADHESION_URL: process.env.ADHESION_URL
};

export default globals;
